(function(){

  /*
   * Her kartta bu script tekrar çalışabiliyor (blok başına <script> var).
   * Kurulum bir kez yapılır, sonraki çalıştırmalar sadece yeni .spv'leri tarar.
   */
  if (window._spvTicker) {
    window._spvTicker.scan(document);
    return;
  }

  /*
   * Eskiden her .spv için ayrı setInterval vardı ve ekran dışındaki / silinmiş
   * kartlarda da animasyon sürüyordu. Çok kartlı listelerde (sonsuz kaydırma)
   * ana thread hiç boşa çıkmıyor, filtreler takılıyordu. Artık tek bir zamanlayıcı
   * sadece ekranda görünen .spv'leri döndürür, DOM'dan çıkanları bırakır.
   */
  var tracked = new Set();
  var visible = new Set();

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        syncTimer();
      }, { rootMargin: '100px' })
    : null;

  function initSpv(wrap) {
    if (wrap.dataset.spvInit) return;
    wrap.dataset.spvInit = '1';

    var items = Array.prototype.slice.call(wrap.querySelectorAll('.spv-item'));
    if (!items.length) return;

    if (items.length === 1) {
      items[0].style.opacity = '1';
      items[0].style.position = 'relative';
      return;
    }

    var speed = (parseInt(wrap.dataset.speed) || 3) * 1000;
    wrap._spv = { items: items, cur: 0, speed: speed, next: Date.now() + speed };

    items[0].classList.add('spv-enter');
    setTimeout(function(){
      items[0].classList.remove('spv-enter');
      items[0].style.opacity = '1';
    }, 420);

    tracked.add(wrap);
    if (io) io.observe(wrap);
    else {
      visible.add(wrap);
      syncTimer();
    }
  }

  function step(wrap) {
    var state = wrap._spv;
    var items = state.items;
    var prev = state.cur;
    var cur = (prev + 1) % items.length;
    state.cur = cur;

    items[prev].classList.add('spv-exit');
    setTimeout(function(){
      items[prev].classList.remove('spv-exit');
      items[prev].style.opacity = '0';
    }, 400);

    setTimeout(function(){
      items[cur].classList.add('spv-enter');
      setTimeout(function(){
        items[cur].classList.remove('spv-enter');
        items[cur].style.opacity = '1';
      }, 450);
    }, 200);
  }

  function release(wrap) {
    tracked.delete(wrap);
    visible.delete(wrap);
    if (io) io.unobserve(wrap);
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Zamanlayıcı sadece ekranda dönen bir satır varken çalışır; yoksa sayfa boşta uyanmaz */
  var timer = 0;
  function syncTimer() {
    if (visible.size && !timer) timer = setInterval(tick, 250);
    else if (!visible.size && timer) {
      clearInterval(timer);
      timer = 0;
    }
  }

  function tick() {
    if (document.hidden || reduceMotion.matches) return;
    var now = Date.now();

    tracked.forEach(function(wrap) {
      if (!wrap.isConnected) return release(wrap);
      if (!visible.has(wrap) || now < wrap._spv.next) return;
      // Hold the line still while it is being read (pointer over it or focus inside)
      if (wrap.matches(':hover') || wrap.contains(document.activeElement)) return;

      wrap._spv.next = now + wrap._spv.speed;
      step(wrap);
    });
    syncTimer();
  }

  function scan(root) {
    if (root.classList && root.classList.contains('spv')) initSpv(root);
    root.querySelectorAll && root.querySelectorAll('.spv').forEach(initSpv);
  }

  window._spvTicker = { scan: scan };

  /* Sayfa ilk yüklendiğinde mevcut tüm spv'leri başlat */
  scan(document);

  /* Sonradan eklenen kartları yakala; sayfa geneli gözlemci olduğu için kare başına tek tarama */
  var queued = false;
  var observer = new MutationObserver(function() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function() {
      queued = false;
      scan(document);
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
